import PTZIcon from "../../assets/product-list-assets/ptz.svg";
import type { ProductListGroup } from "../../types";

export const physicalSecurityPTZ: ProductListGroup = {
  id: "physicalSecurityPTZ",
  title: "productListGroup.ptz.title",
  seriesLabel: "modelCompare.seriesLabel.physicalSecurityPTZ",
  icon: {
    src: PTZIcon,
    width: 16,
    height: 21,
  },
};
